import { Dispatch, SetStateAction } from "react";
import { useDismissToast } from "../../common/hooks/useDismissToast";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import {
  BeginLoadingInput,
  FinishLoadingInput,
  State,
} from "../hooks/useAsyncLoader";
import { finishWithErrors, finishWithSuccess } from "./finishWithStatus";

export function buildFinishLoading<T>(
  setLoading: Dispatch<SetStateAction<State>>,
  setData: Dispatch<SetStateAction<"initial" | T>>,
  key: DataTestids,
  dismissToast: ReturnType<typeof useDismissToast>,
  beginLoadingInput?: BeginLoadingInput
) {
  return function finishLoading(input: FinishLoadingInput<T>) {
    switch (input.tag) {
      case "data":
        return finishWithSuccess<T>(
          input,
          setLoading,
          setData,
          beginLoadingInput,
          key,
          dismissToast
        );
      case "errors":
        // ideally, this would log to a service
        // eslint-disable-next-line no-console
        console.warn(input.uuid);
        return finishWithErrors(input, setLoading, beginLoadingInput, key);
    }
  };
}
